// @flow
import resolveFormInputs from '@hbrisk/sp3-risk-model-support/utility/form/resolveFormInputs/index.js';
import byField from '@hbrisk/sp3-risk-model-support/utility/form/formInputsTransforms/byField/index.js';
import getFieldPermissionOverrides from '@hbrisk/sp3-risk-model-support/utility/form/getFieldPermissionOverrides/index.js';
import { modelTypesById } from '#constants/models/modelTypes/index.js';

type FormInputMap = {
  [field: string]: {
    value: string | null,
    visible: boolean,
    autofilled: false,
  },
};

type CalculateNewModelPostPayload = (
  type: number,
  createdById: string,
  orgId: string,
  permissions: {}
) => {
  formInputs: FormInputMap,
  type: number,
  createdById: string,
  orgId: string,
};

/**
 * Calculates the payload for creating a new model on the server from the model's type and the
 * user's permissions. Model creation is a single step with **no name argument** -- a model's name
 * is an ordinary in-form field (`MODEL_NAME`, in Model & Site Info) the user can set later, and one
 * that extraction may itself propose (UI design §2.1; issue #127). The payload carries only the
 * resolved default `formInputs` for the type.
 */
const calculateNewModelPostPayload: CalculateNewModelPostPayload = (
  type,
  createdById,
  orgId,
  permissions
) => {
  const { fields } = modelTypesById[type];

  const overrides = getFieldPermissionOverrides(fields, permissions);

  const formInputsBySlice = resolveFormInputs(fields, { visibleFields: overrides });

  const formInputs = byField(formInputsBySlice, fields);

  return {
    formInputs,
    type,
    createdById,
    orgId,
  };
};

export default calculateNewModelPostPayload;
